/**
 * The kinds of bulk import (a userImports doc's importType) and what the history calls
 * them. Only users imports exist so far; clients and claims are here so the Type filter
 * already offers them.
 */
export const IMPORT_TYPES = [
	{ id: 'users', name: 'Users' },
	{ id: 'clients', name: 'Clients' },
	{ id: 'claims', name: 'Claims' },
];
